// extracted by mini-css-extract-plugin
export default {"verifiedEmail":"VerifiedEmailModal_verifiedEmail__UXFgd"};